export const serviceObjOne = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Freelance Work Support',
  headline: 'Expert help for your freelance projects and tech challenges',
  description:
    'Get guidance, code review, and real-world solutions for your freelance software engineering work.',
  buttonLabel: 'Get Help',
  imgStart: '',
  img: require('../../images/freelance-software-engineering.png').default,
  alt: 'Freelance Support'
};

export const serviceObjTwo = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Technical Interview Prep',
  headline: 'Ace your next interview with confidence',
  description:
    'Practice coding, system design, and behavioral interviews with experienced engineers.',
  buttonLabel: 'Start Practicing',
  imgStart: 'start',
  img: require('../../images/300b300.png').default,
  alt: 'Interview Prep'
};

export const serviceObjThree = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: '1:1 Coaching & Counseling',
  headline: 'Personalized career and technical guidance',
  description:
    'Book sessions for career advice, technical mentoring, and personal growth with our experts.',
  buttonLabel: 'Book a Session',
  imgStart: '',
  img: require('../../images/developer-coaching.jpeg').default,
  alt: 'Coaching'
};

export const serviceObjFour = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Software Engineering Courses',
  headline: 'Learn modern software engineering skills',
  description:
    'Access high-quality courses on data structures, algorithms, OOP, and more.',
  buttonLabel: 'Browse Courses',
  imgStart: 'start',
  img: require('../../images/400b400.png').default,
  alt: 'Courses'
};
  